import { useEffect } from 'react';
import { useApp } from '../lib/AppContext';
import { CheckCircle, XCircle } from 'lucide-react';

interface ToastProps {
  message?: string;
  type?: 'success' | 'error';
  onClose?: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  const { toastMessage, clearToast } = useApp();

  // Support both prop-based and context-based usage
  const displayMessage = message || toastMessage?.title;
  const displayType = type || 'success';
  const handleClose = onClose || clearToast;

  useEffect(() => {
    if (displayMessage) {
      const timer = setTimeout(handleClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [displayMessage, handleClose]);

  if (!displayMessage) return null;

  const borderColor = displayType === 'error' ? 'border-red-500' : 'border-[#40E0D0]';
  const Icon = displayType === 'error' ? XCircle : CheckCircle;
  const iconColor = displayType === 'error' ? 'text-red-500' : 'text-[#40E0D0]';

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[200] animate-slide-down">
      <div className={`bg-[#181818] border ${borderColor} rounded-xl px-6 py-3 shadow-lg max-w-sm flex items-center gap-3`}>
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <div className="flex-1">
          <p className="text-[14px] font-semibold text-[#F5F5F5]">
            {displayMessage}
          </p>
          {toastMessage?.subtitle && !message && (
            <p className="text-[13px] text-[#A0A0A0] mt-1">
              {toastMessage.subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
